import { render, staticRenderFns } from "./FilterTagSwitch.vue?vue&type=template&id=92a8aa14"
import script from "./FilterTagSwitch.vue?vue&type=script&lang=js"
export * from "./FilterTagSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports